import { getCameraPoseClickedMessage } from 'features/kestrelViewer/messages/cameraPoseClicked'
import { getConfirmIdMessage } from 'features/kestrelViewer/messages/confirmId'
import { getControlMessage } from 'features/kestrelViewer/messages/control'
import { getCurrentCameraPoseResultMessage } from 'features/kestrelViewer/messages/currentCameraPoseResult'
import { getCurrentCameraViewResultMessage } from 'features/kestrelViewer/messages/currentCameraViewResult'
import {
  getCursorDataMessage,
  getCursorTemperatureMessage,
} from 'features/kestrelViewer/messages/cursorTemperature'
import { getNewCameraViewMessage } from 'features/kestrelViewer/messages/newCameraView'
import { getNewMeasurementMessage } from 'features/kestrelViewer/messages/newMeasurement'
import { getNewPointAnnotationMessage } from 'features/kestrelViewer/messages/newPointAnnotation'
import { getSetMeasurementScaleMessage } from 'features/kestrelViewer/messages/setMeasurementScale'
import { getSettingsUpdatedMessage } from 'features/kestrelViewer/messages/settings'
import { getSliceOnOrbitMessage } from 'features/kestrelViewer/messages/sliceOnOrbit'
import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'

import { getBatchScreenshotCompleteMessage } from './batchScreenshotComplete'
import { getBatchScreenshotProgressMessage } from './batchScreenshotProgress'
import { getInspectionAreaLabelClickedMessage } from './inspectionAreaLabelClicked'
import { getNavigationModeUpdatedMessage } from './navigationModeUpdated'
import { getNewInspectionAreaMessage } from './newInspectionArea'
import { getNewInspectionAreaBatchMessage } from './newInspectionAreaBatch'
import { getNewPlaneIntersectionMessage } from './newPlaneIntersection'
import { getNewPolygonAnnotationMessage } from './newPolygonAnnotation'
import { getNewPolygonAnnotationsBatchMessage } from './newPolygonAnnotationsBatch'
import { getNewPrimitiveMessage } from './newPrimitive'
import { getNewStartingViewMessage } from './newStartingView'
import { getOrbitPlacedMessage } from './orbitPlaced'
import { getPoseScreenshotResultMessage } from './poseScreenshotResult'
import { getPrimitiveUpdatedMessage } from './primitiveUpdated'
import { roofOutlineGenerationResult } from './roofOutlineGenerationResult'
import { getSelectPolygonMessage } from './selectPolygon'
import { getInspectionAreaUpdatedMessage } from './updateInspectionArea'
import { getUpdatePolygonMessage } from './updatePolygon'

export type KVMessageDef = {
  type: string
  requiredData: string[]

  callback: (
    json: Record<string, unknown>,
    kv: KestrelViewerMessageCallbackAPI
  ) => void
}

export function getAllMessages(): KVMessageDef[] {
  return [
    getConfirmIdMessage(),
    getControlMessage(),
    getCurrentCameraViewResultMessage(),
    getCurrentCameraPoseResultMessage(),
    getCursorDataMessage(),
    getCursorTemperatureMessage(),
    getNewPointAnnotationMessage(),
    getNewMeasurementMessage(),
    getNewCameraViewMessage(),
    getSetMeasurementScaleMessage(),
    getSliceOnOrbitMessage(),
    getSettingsUpdatedMessage(),
    getNewPlaneIntersectionMessage(),
    getPrimitiveUpdatedMessage(),
    getNewPolygonAnnotationMessage(),
    getNewPolygonAnnotationsBatchMessage(),
    getCameraPoseClickedMessage(),
    getOrbitPlacedMessage(),
    getNavigationModeUpdatedMessage(),
    getNewStartingViewMessage(),
    getPoseScreenshotResultMessage(),
    getBatchScreenshotProgressMessage(),
    getBatchScreenshotCompleteMessage(),
    getSelectPolygonMessage(),
    getUpdatePolygonMessage(),
    getNewInspectionAreaMessage(),
    getInspectionAreaUpdatedMessage(),
    getInspectionAreaLabelClickedMessage(),
    getNewPrimitiveMessage(),
    roofOutlineGenerationResult(),
    getNewInspectionAreaBatchMessage(),
  ]
}
